import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import QrReader from "react-qr-reader";
import {connect} from "react-redux";
import {Link, Route, Switch} from "react-router-dom";
import logo from "../../assets/img/logo.svg";
import ScanSound from "../../assets/sound/Scan.mp3";
import {GetQrTableCart} from "../../redux/actions/Cart.Action";
import {NewCategory, NewProductList,} from "../../redux/actions/Product.Action";
import Header from "../Components/Headers";
import ProductGrid_Waiter from "./Page/ProductGrid_Waiter";
import TableDetails from "./Page/TableDetails";
import WaiterCart from "./Page/WaiterCart";

class Waiter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baseurl: props.match.path,
      showModal: false,
    };
    this.audio = typeof Audio !== "undefined" && new Audio(ScanSound);
    // this.props.history.push("/Waiter/ProductList");
  }
  handleScan = (data) => {
    if (data) {
      this.audio.play();
      if (this.props.GetQrTableCart(data)) {
        this.props.history.push("/Waiter/ProductList");
        this.setState({ showModal: false });
      }
    }
  };
  handleError = (err) => {
    console.error(err);
  };
  handle_closeModal() {
    this.setState({ showModal: false });
  }
  render() {
    const CurrentCart = this.props.CurrentCart;
    return (
      <React.Fragment>
        <div className="row p-0 m-0">
          <Header Layout="Waiter" />
          <main className="container-fluid pt-60">
            <Switch>
              <Route path={this.state.baseurl} exact component={TableDetails} />
              <Route
                path={this.state.baseurl + `/ProductList`}
                exact
                component={ProductGrid_Waiter}
              />
              <Route
                path={this.state.baseurl + `/TableCart`}
                exact
                component={WaiterCart}
              />
            </Switch>
          </main>
        </div>
        {/* <footer
          className="site-footer p-10 row fixed-bottom"
          style={{ display: !this.props.screenLock ? "block" : "none" }}
        >
          <div className="row">
            <button
              className="nav-scan-button btn btn-float btn-primary"
              onClick={() => this.setState({ showModal: true })}
            >
              <span className="material-icons-outlined">qr_code_scanner</span>
            </button>
            <div className="col text-center">
              <Link
                className="nav-link"
                to={this.state.baseurl + "/ProductList"}
              >
                <span className="material-icons-outlined fs-30">store</span>
              </Link>
              <span className="p-0">Products</span>
            </div>
            <div className="col text-center">
              <div className="nav-link pt-35">Scan&Order</div>
            </div>
            <div className="col text-center">
              <Link className="nav-link" to={this.state.baseurl + "/TableCart"}>
                <span className="material-icons-outlined fs-30">
                  shopping_basket
                </span>
                {CurrentCart && this.props.CurrentCart.length !== 0 ? (
                  <span className="badge badge-pill badge-info">
                    {this.props.Orderlist.length}
                  </span>
                ) : (
                  ""
                )}
              </Link>
              <span className="p-0">Cart</span>
            </div>
          </div>
        </footer> */}

        <footer
          className="fixed-bottom waiter-footer"
          style={{ display: !this.props.screenLock ? "flex" : "none" }}
        >
          <Link to={this.state.baseurl}>
            <span className="material-icons-outlined">deck</span>
            <span className="title">Table</span>
          </Link>
          <Link to={this.state.baseurl + "/ProductList"}>
            <span className="material-icons-outlined">store</span>
            <span className="title">Products</span>
          </Link>
          <a
            href="#ScanOrder"
            className="scan"
            onClick={() => this.setState({ showModal: true })}
          >
            <span className="material-icons-outlined bg-primary">
              qr_code_scanner
            </span>
          </a>
          <Link to={this.state.baseurl + "/TableCart"}>
            <span className="material-icons-outlined">receipt_long</span>
            <span className="title">Orders</span>
          </Link>
          <Link to={this.state.baseurl + "/TableCart"}>
            <span className="material-icons-outlined">shopping_basket</span>
            {CurrentCart && this.props.CurrentCart.length !== 0 ? (
              <span className="badge badge-sm badge-dot badge-danger"></span>
            ) : (
              ""
            )}
            <span className="title">Cart</span>
          </Link>
        </footer>

        <Modal
          show={this.state.showModal}
          className="modal-fill modal-fullscreen bg-theme"
          fullscreen="true"
          onHide={() => this.handle_closeModal()}
          style={{ height: "100vh" }}
        >
          <div className="d-inline align-items-center justify-content-center QR-modal text-center">
            <div className="text-center">
              <img
                src={logo}
                width="90"
                alt="logo"
                style={{ maxHeight: "80px" }}
              />
              <p className="fs-25 pt-30">Scan & Order</p>
              <p>Please align the QR within the frame</p>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <QrReader
                delay={300}
                onError={this.handleError}
                onScan={this.handleScan}
                style={{ width: "70%", height: "auto" }}
              />
            </div>
            <button
              className="btn btn-danger mt-40"
              onClick={() => this.handle_closeModal()}
            >
              Close
            </button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    ProductList: state.Products.FilterProduct,
    CurrentCart: state.Cart.CurrentCart,
    Orderlist: state.Cart.CurrentCart.order,
    screenLock: state.Auth.lockScreen,
  }),
  { NewProductList, NewCategory, GetQrTableCart }
)(React.memo(Waiter));
